<template>
  <section class="content">
    <loader v-show="loading"></loader>
    <vuetable
      v-show="!loading"
      :tableData="tableData"
      :tableTitle="'Exchange Rate Histories'"
      :fields="fields"
      v-on:pages-remaining="loadMore"
      :maxItems="maxValue"
    ></vuetable>
  </section>
</template>
<script>
  import vuetable from '../../../helpers/VueTable.vue'
  import Loader from '../../../helpers/Loader.vue'
  import AdminSearchResults from '../../mixins/AdminSearchResultsMixin.js'
  import { fromTimestamp } from '../../../helpers/DateHelpers'
  export default {
    name: 'ExchangeRateHistorySearchResults',
    components: {
      vuetable: vuetable,
      Loader
    },
    mixins: [ AdminSearchResults ],
    data () {
      return {
        loading: false,
        tableData: [],
        lazy: '0',
        entityName: 'exchange-rate-history',
        editEntityScreen: 'Admin - Edit/View Exchange Rate History',
        fields: [
          {
            header: 'Exchange Rate',
            prop: (item) => {
              let from = item.exchangeRate !== null && item.exchangeRate.fromCurrency !== null ? item.exchangeRate.fromCurrency.code : 'N/A'
              let to = item.exchangeRate !== null && item.exchangeRate.toCurrency !== null ? item.exchangeRate.toCurrency.code : 'N/A'
              return `${from} --> ${to}`
            }
          },
          { header: 'Rate (was)', prop: 'rateWas' },
          { header: 'Rate (now)', prop: 'rateNow' },
          { header: 'Inverse (was)', prop: 'inverseWas' },
          { header: 'Inverse (now)', prop: 'inverseNow' },
          {
            header: 'Last Updated',
            prop: (item) => {
              if (item.dateOfChange) {
                return fromTimestamp(item.dateOfChange)
              }
            }
          }
        ],
        shouldSearchForExactMatch: true,
        orderBy: 'exchangeRate'
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// ExchangeRateHistorySearchResults.vue?2453e160